import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postMipInvestorsInvitations } from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service.ts';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2.tsx';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { SendInvestorInviteDto } from '@dealstack/shared/lib/generated';

export const useInviteInvestmentWorkflowMutation = (mipId: string) => {
	const queryClient = useQueryClient();
	const tMipManage = useTranslationMipManage();

	return useMutation({
		mutationFn: (payload: SendInvestorInviteDto) => postMipInvestorsInvitations(payload),
		onSuccess: async () => {
			await queryClient.invalidateQueries({
				queryKey: [
					formatUnicorn(
						API_PATHS.MIP_MIPID_INVESTOR_INVESTMENT_WORKFLOW_MIP_INVESTMENTS_LIST_POST,
						{ mipId }
					),
				],
			});
			showToastV2({
				title: tMipManage('send_modal.toast.success.title'),
				state: 'success',
			});
		},
		onError: () => {
			showToastV2({
				title: tMipManage('send_modal.toast.error.title'),
				state: 'error',
			});
		},
	});
};
